export const HardwareSubCmds = {
    Limited_Sync: 'LIMITED_SYNC',
    Sync_Controllers: 'SYNC_CONTROLLERS',
    Sync_Idemia: 'SYNC_IDEMIA',
    Sync_ControlId: 'SYNC_CONTROLID',
    Sync_hikVision: 'SYNC_HIK_VISION',
    Sync_hidAmico: 'SYNC_HID_AMICO',

    Discover_Controllers: 'DISCOVER_CONTROLLERS',
    Discover_Idemia: 'DISCOVER_IDEMIA',
    Discover_ControlId: 'DISCOVER_CONTROLID',
    Discover_Morpho: 'DISCOVER_MORPHO',
    Discover_Suprema: 'DISCOVER_SUPREMA',
    Discover_HIK_Vision: 'DISCOVER_HIK_VISION',
    Discover_RB25F: 'DISCOVER_RB25F',
    Discover_IBR: 'DISCOVER_IBR',
    Scan_Rs485: 'SCAN_RS485',

    Install_Controller: 'INSTALL_CONTROLLER',
    Uninstall_Controller: 'UNINSTALL_CONTROLLER',
    Uninstall_Reader: 'UNINSTALL_READER',

    Send_Generate_Upload: 'GENERATE_SEND_CERTIFICATE',
    Send_Certificate: 'SEND_CERTIFICATE',
    Certificate_Refresh: 'CERTIFICATE_REFRESH',

    UserId_List: 'USER_ID_LIST',
    Open_Door: 'OPEN_DOOR',
    VERIFY_DEVICE_PASSWORD: 'VERIFY_DEVICE_PASSWORD'
}

export const MQTTHardwareSubCmds = {
    MQTT_Discovery: 'MQTT_DISCOVERY',
    MQTT_Controller_Ping: 'MQTT_CONTROLLER_PING',
}

export const EnrolSubCmds = {
    Enroll_MSO300_Response: 'ENROLL_MSO300_RESP',
    Enroll_IdBio_Response: 'ENROLL_IDBIO_RESP',
    Enroll_Devices_Available: 'ENROLL_DEVICES_AVAILABLE',
}

export const MonitoringSubCmds = {
    Test_Resend_Transactions: "TEST_RESEND_TRANSACTIONS",
}

export const EngineSubCmds = {
    Is_Engine_Started: "IS_ENGINE_STARTED",
    Start_Sync: "START_SYNC",
    Stop_Sync: "STOP_SYNC",
}

export const HidMobileAccessSubCmds = {
    PartNumbers: "MA_QUERY_PART_NUMBERS",
    Generate_Credential: "MA_GENERATE_CRED_ID",
}

export const StidMobileSubCmds = {
    Get_Sites: "STID_GET_SITES",
    Get_Available_Credits: "STID_GET_AVAILABLE_CREDITS",
    Generate_Credential: "STID_GENERATE_CRED_ID",
    Get_Details: "STID_GET_DETAILS",
}

export const MaintenanceSubCmds = {
    All_Allowed_Action: "ALL_ALLOWED_ACTION",
    All_Denied_Action: "ALL_DENIED_ACTION",
    Delete_Master_Detail: "DELETE_MASTER_DETAIL",
    Toggle_State: "TOGGLE_STATE",
}

export const AccountSubCmds = {
    Test_Account: "TEST_ACCOUNT",
    CRL_REFRESH: "CRL_MANUAL_REFRESH",
    CRL_REMOVE: "CRL_REMOVE",
    CRL_FILE_IMPORT: "CRL_FILE_IMPORT",
    Restart_MQTT_Broker: "MQTT_BROKER_CONFIG_UPDATE",
    Sync_Vingcard_Now: "VINGCARD_SYNC_NOW",
    Encode_Vingcard_User: "VINGCARD_ENCODE_USER",
    Reset_Mfa: "MFA_GOOGLE_RESET"
}

export const AreaSubCmds = {
    ADD_CONTROLLER_AREA_LOCATION:"ADD_CONTROLLER_AREA_LOCATION",
    DELETE_CONTROLLER_AREA_LOCATION:"DELETE_CONTROLLER_AREA_LOCATION",
    ADD_ZONE_AREA_LOCATION:"ADD_ZONE_AREA_LOCATION",
    DELETE_ZONE_AREA_LOCATION:"DELETE_ZONE_AREA_LOCATION",
    ADD_BUILDING_AREA_LOCATION: "ADD_BUILDING_AREA_LOCATION",
    DELETE_BUILDING_AREA_LOCATION: "DELETE_BUILDING_AREA_LOCATION"
}

export const MqttSubCmds = {
    LOAD_KEYSTORE_CERT_ALIASES: "LOAD_KEYSTORE_CERTIFICATE_ALIASES"
}

export const LdapSubCmds = {
    LDAP_SEARCH_USERS_BY_CN: "LDAP_SEARCH_USERS_BY_CN"
}

export const authSubCmds = {
    ENTRA_SEARCH_USERS_BY_CN: "ENTRA_SEARCH_USERS_BY_CN",
    ENTRA_SEARCH_GROUPS_BY_CN: "ENTRA_GROUP_SEARCH_BY_CN"
}
